import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faClock } from '@fortawesome/pro-light-svg-icons';
import OrderService from '../../../services/orders/order';
import styles from './styles.module.scss';

export interface ActiveOrderItem {
    id: string;
    code: string;
    origin: string;
    destination: string;
    link?: string;
}

interface IActiveOrdersWidgetProps {
    totalActiveCount?: number;
    activeOrders?: ActiveOrderItem[];
    oldestDays?: number;
    onViewAll?: () => void;
}

const ActiveOrdersWidget: React.FC<IActiveOrdersWidgetProps> = ({
    totalActiveCount: initialCount,
    activeOrders: initialOrders,
    oldestDays = 16,
    onViewAll,
}) => {
    const [orders, setOrders] = useState<ActiveOrderItem[]>(initialOrders || []);
    const [totalCount, setTotalCount] = useState<number>(initialCount || 0);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const res = await OrderService.retrieve('top=10');
                if (res && res.data && res.data.length > 0) {
                    setTotalCount(res.pagination?.total || res.data.length);
                    const mapped: ActiveOrderItem[] = res.data.map((order: any) => {
                        const codeStr = order.orderNumber ? `#${OrderService.getOrderNumber(order.orderNumber)}` : order.id;
                        const originStr = order.originAddresses && order.originAddresses[0] ? (order.originAddresses[0].city || order.originAddresses[0].address) : 'Asal';
                        const destStr = order.destinationAddresses && order.destinationAddresses[0] ? (order.destinationAddresses[0].city || order.destinationAddresses[0].address) : 'Tujuan';

                        return {
                            id: order.id,
                            code: codeStr,
                            origin: originStr,
                            destination: destStr,
                            link: `/orders/${order.id}`
                        };
                    });
                    setOrders(mapped);
                }
            } catch (e) {
                console.error('Failed to fetch active orders for widget', e);
            }
        };

        fetchOrders();
    }, []);

    return (
        <div className={styles.container}>
            <h2 className={styles.widgetTitle}>Order aktif menurut status</h2>

            {/* Status bar */}
            <div className={styles.statusBar}>
                <div className={styles.statusHeader}>
                    <span className={styles.statusName}>Order Aktif</span>
                    <span className={styles.badgeCount}>{totalCount || orders.length}</span>
                </div>
                <div className={styles.progressBarTrack}>
                    <div className={styles.progressBarFill} style={{ width: '100%' }} />
                </div>
                <div className={styles.statusDesc}>100% order aktif</div>
            </div>

            {/* Monitoring list */}
            <div className={styles.monitoringSection}>
                <div className={styles.monitoringHeader}>
                    <div className={styles.titleWithIcon}>
                        <FontAwesomeIcon icon={faClock} className={styles.clockIcon} />
                        <span>Order Aktif perlu dipantau</span>
                    </div>
                    <span className={styles.agingInfo}>Tertua {oldestDays} hari</span>
                </div>

                <div className={styles.orderList}>
                    {orders.map((item) => (
                        <a
                            key={item.id || item.code}
                            href={item.link || `/orders/${item.id}`}
                            className={styles.orderItem}
                        >
                            <div className={styles.orderInfo}>
                                <span className={styles.orderCode}>{item.code}</span>
                                <span className={styles.orderRoute}>
                                    {item.origin} &rarr; {item.destination}
                                </span>
                            </div>
                            <FontAwesomeIcon icon={faArrowRight} className={styles.arrowIcon} />
                        </a>
                    ))}
                </div>

                <a
                    href="/orders"
                    className={styles.viewAllBtn}
                    onClick={(e) => {
                        if (onViewAll) {
                            e.preventDefault();
                            onViewAll();
                        }
                    }}
                >
                    <span>Lihat semua {totalCount || orders.length} order</span>
                    <FontAwesomeIcon icon={faArrowRight} />
                </a>
            </div>
        </div>
    );
};

export default ActiveOrdersWidget;
